import { Component, inject } from '@angular/core';
import { UserService } from '../../services/user.service';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import {
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';

@Component({
  selector: 'app-login',
  imports: [MatDialogTitle,
      MatDialogContent,
      MatDialogActions,
      MatButtonModule,
      CommonModule,
      MatInputModule,
      MatCardModule,
      MatFormFieldModule,
      ReactiveFormsModule
    ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  private _formBuilder = inject(FormBuilder);
  readonly dialogRef = inject(MatDialogRef<LoginComponent>);

  userService = inject(UserService);
  linkSent = false;
  loginFormGroup = this._formBuilder.group({
    email: ['', [Validators.required, Validators.email]],
  });

  onSubmit() {
    const values = this.loginFormGroup.value;
    this.userService
      .sendMagicLink(
        values.email || '',
      )
      .subscribe((response:any) => {
        this.linkSent = true;
      });
  }
  
  onOkClick(): void {
    this.dialogRef.close();
  }


}
